module.exports = __webpack_public_path__ + "components/weather-icon/static/nightlightrain-f9af49b70b36d6e8375554671ff56d16.svg";